module.exports = __webpack_public_path__ + "static/media/star.a69ff7ee.svg";